import "../App.css";

function AboutMe() {
  return (
    <section id="aboutme" className="aboutme">
      <div className="content">
        <h2 className="aboutme__title">Обо мне</h2>
        <div className="about-wrap">
          <div className="about-wrap__text">
            <p className="aboutme__text">
              Свой путь начинал в 2020 году, когда все бросились в онлайн, и с
              первого проекта я понял: клиенту важен не столько стек, сколько
              результат, а именно работающий сайт, довольные пользователи, рост
              заявок.
            </p>
            <p className="aboutme__text">
              Поэтому в работе я орентируюсь ясность: задаю уточняющие вопросы,
              предлагаю варианты реализации, веду прозрачную коммуникацию. Мне
              доверяли доработку личных кабинетов для госпроектов и создание
              интернет-магазинов с нуля.
            </p>
            <p className="aboutme__text">
              Я в состою в крупном сообществе разработчиков, перенимаю лучшие
              практики и сразу проверяю их в работе. Недавно углубил знания
              через «Код будущего» и подтвердил навыки через ИТ-Компетенции.
            </p>
          </div>
          <img
            className="aboutme__img"
            src="/mackbook.jpg"
            alt="Дмитрий Сахаров"
            fetchpriority="low"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutMe;
